import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '健康运动看我的｜2023重庆渝快保运动健康达人短视频大赛';
const baseUrl = '20221121JKDR';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    // {
    //   path: 'save',
    //   name: `${baseUrl}-save`,
    //   component: () => import('./pages/Save.vue'),
    //   meta: {
    //     title: PAGE_TITLE,
    //   },
    // },
    {
      path: 'activity',
      name: `${baseUrl}-activity`,
      component: () => import('./pages/Activity.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'activityDetail',
      name: `${baseUrl}-activityDetail`,
      component: () => import('./pages/ActivityDetail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
  ],
};

export default route;
